import { render } from "./all-kompetensi.vue?vue&type=template&id=2c6a3110&scoped=true"
import script from "./all-kompetensi.vue?vue&type=script&lang=js"
export * from "./all-kompetensi.vue?vue&type=script&lang=js"

import "./all-kompetensi.vue?vue&type=style&index=0&id=2c6a3110&lang=css"
import "./all-kompetensi.vue?vue&type=style&index=1&id=2c6a3110&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6a3110"]])

export default __exports__